export const FEATURED_PRODUCT_REQUEST = 'FEATURED_PRODUCT_REQUEST'
export const FEATURED_PRODUCT_SUCCESS = 'FEATURED_PRODUCT_SUCCESS'
export const FEATURED_PRODUCT_FAIL = 'FEATURED_PRODUCT_FAIL'

export const FEATURED_BRAND_REQUEST = 'FEATURED_BRAND_REQUEST'
export const FEATURED_BRAND_SUCCESS = 'FEATURED_BRAND_SUCCESS'
export const FEATURED_BRAND_FAIL = 'FEATURED_BRAND_FAIL'
